import React from "react";
import "./index.css";

const Header = React.lazy(() => import("./headers/header"));
const Home = React.lazy(() => import("./home/home"));
const About = React.lazy(() => import("./about/About"));
const Skills = React.lazy(() => import("./skills/Skills"));
const Contact = React.lazy(() => import("./contacts/Contact"));

function App() {
  return (
    <div className="w-full">
      <Header />
      <main className="w-full flex flex-col">
        <Home />
        <About />
        <Skills />
        <Contact />
      </main>
    </div>
  );
}

export default App;
